import * as marietta from '../..';

class WebCADMessages {
      static ERROR_TITLE_JP: string = '警告';

      static ERROR_TITLE_EN: string = 'Warning';

      static ERROR_JWW_ENTRANCE_JP: string = 'JWW出力には玄関が必要です。<br>玄関を入力してください。';

      static ERROR_JWW_ENTRANCE_EN: string = 'Jww export required an entrance.<br>Please input an entrance.';

      static ERROR_NEED_ENTRANCE_JP: string = '3Dモードには玄関が必要です。<br>玄関を入力してください。';

      static ERROR_NEED_ENTRANCE_EN: string = '3D mode required an entrance.<br>Please input an entrance.';

      static ERROR_3D_COMPATIBILITY_JP: string = 'WebGLに対応していない端末のため、<br/>Lowモードで起動しています。<br/>3Dは表示できません。';

      static ERROR_3D_COMPATIBILITY_EN: string = 'WebGL is not compatible with your computer.<br/>Running on 2D only mode.';

      static ERROR_NO_ROOMS_JP: string = '部屋がありません。<br>部屋を入力してください。';

      static ERROR_NO_ROOMS_EN: string = 'There are no rooms.<br>Please input a room.';

      static ERROR_NEED_2NDFLOOR_JP: string = '2Fに部屋がありません。<br>部屋を入力してください。';

      static ERROR_NEED_2NDFLOOR_EN: string = 'There are no rooms on the 2nd floor.<br>Please input a room.';

      static ERROR_NEED_3RDFLOOR_JP: string = '3Fに部屋がありません。<br>部屋を入力してください。';

      static ERROR_NEED_3RDFLOOR_EN: string = 'There are no rooms on the 3rd floor.<br>Please input a room.';

      static ERROR_NEED_ENTRANCE_AUTO_JP: string = '廊下自動生成には玄関が必要です。 <br>玄関を配置してください。';

      static ERROR_NEED_ENTRANCE_AUTO_EN: string = 'Auto hallway generation requires an entrance input.<br>Please input an entrance.';

      static ERROR_HAS_SEPERATED_ROOM_JP: string = '隣接していない部屋があります。 <br>間取りを修正してください。';

      static ERROR_HAS_SEPERATED_ROOM_EN: string = 'There is a sperated room.<br>Please fix the floor plan.';

      static ALERT_NO_ENTRANCE_JP: string = '玄関が配置されていません。<br>建物の中へ移動する場合は、マップをクリックして移動してください。';

      static ALERT_NO_ENTRANCE_EN: string = 'No entrance found.<br>Click on the map in order to get into the building.';

      static ALERT_MOVE_MAP_JP = '建物の中を移動する場合は、マップをクリックすると移動ができます。';

      static ALERT_MOVE_MAP_EN = 'To move through the building, click on the map.';

      static ERROR_NEED_SITE_JP: string = '敷地の入力が必要です。<br>2Dモードで敷地を入力してからお試しください。';

      static ERROR_NEED_SITE_EN: string = 'In order to calculate the site regulations, you need to input a site.<br>Please go back to the 2D mode and input your site and try again.';

      static ALERT_LOAD_DRAFT_JP: string = '下絵読込をしてください。';

      static ALERT_LOAD_DRAFT_EN: string = 'Please load the draft picture';

      static ERROR_OFFLINE_JP: string = 'オフラインです。<br>ネットワーク環境をご確認ください。';

      static ERROR_OFFLINE_EN: string = 'Cannot find online connection.<br>Please check your network connection.';

      static ERROR_SERVER_BUSY_JP: string = 'ただいま、サーバが大変混み合っております。しばらくしてから、お試しください。';

      static ERROR_SERVER_BUSY_EN: string = 'The server seems to be busy at this moment.<br>Please try again later.';

      static ERROR_DRAFT_FAIL_JP: string = '下絵の読込に失敗しました。<br> PNG、JPEG、GIF形式の画像を選択してください。';

      static ERROR_DRAFT_FAIL_EN: string = 'Failed to load the draft picture.<br>Please select a PNG, JPEG or GIF format file.';

      static ERROR_LOAD_FAIL_JP: string = 'ファイルの読込に失敗しました。';

      static ERROR_LOAD_FAIL_EN: string = 'Failed to load file.';

      static ERROR_EXPORT_FAIL_JP: string = 'プランデータのエクスポートに失敗しました。';

      static ERROR_EXPORT_FAIL_EN: string = 'Failed to export plan data.';

      static ERROR_EXPORT_COLLADA_FAIL_JP: string = 'プランデータのColladaエクスポートに失敗しました。';

      static ERROR_EXPORT_COLLADA_FAIL_EN: string = 'Failed to export Collada data.';

      static ERROR_EXPORT_SEKISAN_FAIL_JP: string = 'プランの積算情報エクスポートに失敗しました。';

      static ERROR_EXPORT_SEKISAN_FAIL_EN: string = 'Failed to export cost info data.';

      static ERROR_IMPORT_FAIL_JP: string = 'プランデータのインポートに失敗しました。';

      static ERROR_IMPORT_FAIL_EN: string = 'Failed to import plan data.';

      static ERROR_SAVE_NOPLAN_JP: string = '保存する間取りがありません。<br>間取りを作成してから保存してください。';

      static ERROR_SAVE_NOPLAN_EN: string = 'Please draw your floor plan before saving.';

      static ALERT_INPUT_PLANNAME_JP: string = 'プラン名を入力してください。';

      static ALERT_INPUT_PLANNAME_EN: string = 'Please input the plan name.';

      static NOTICE_SAVED_JP: string = '保存しました。';

      static NOTICE_SAVED_EN: string = 'Saved.';

      static BUSY_CONNECTING_JP: string = 'サーバ通信中･･･';

      static BUSY_CONNECTING_EN: string = 'Loading...';

      static BUSY_CALCULATING_JP: string = '計算中･･･';

      static BUSY_CALCULATING_EN: string = 'Calculating...';

      static BUSY_REQUESTING_3D_JP: string = '3Dリクエスト中';

      static BUSY_REQUESTING_3D_EN: string = 'Requesting 3D';

      static BUSY_PREPARING_DATA_JP: string = '送信データ準備中';

      static BUSY_PREPARING_DATA_EN: string = 'Preparing Data';

      static BUSY_DOWNLOAD_MATERIAL_JP: string = 'マテリアルのダウンロード中';

      static BUSY_DOWNLOAD_MATERIAL_EN: string = 'Downloading Materials';

      static BUSY_DOWNLOAD_MODEL_JP: string = 'モデルのダウンロード中';

      static BUSY_DOWNLOAD_MODEL_EN: string = 'Downloading Models';

      static BUSY_LOADING_3D_OBJECT_JP: string = '3Dオブジェクトのロード中';

      static BUSY_LOADING_3D_OBJECT_EN: string = 'Loading 3D Objects';

      static NOTICE_REQUEST_SENT_JP: string = '投稿が完了しました。';

      static NOTICE_REQUEST_SENT_EN: string = 'Your request has been sent. Thank you.';

      static ERROR_SELECT2_ROOMS_JP: string = '部屋を２つ選択してください。';

      static ERROR_SELECT2_ROOMS_EN: string = 'Please select 2 rooms.';

      static ERROR_JOIN_ROOMS_JP: string = '部屋を結合できませんでした。<br>選択した部屋の確認をしてください。';

      static ERROR_JOIN_ROOMS_EN: string = 'Could not join the rooms.<br>Please check the rooms you have selected.';

      static ERROR_NO_FITTINGFITS_JP: string = 'こちらに建具を配置できません。';

      static ERROR_NO_FITTINGFITS_EN: string = 'Cannot place a fitting here.';

      static IOS_ERROR_TITLE_JP: string = 'ご注意';

      static IOS_ERROR_TITLE_EN: string = 'Warning';

      static IOS_ERROR_MESSAGE_JP: string = 'iOS8以下は対応していません。<br>ご注意ください';

      static IOS_ERROR_MESSAGE_EN: string = 'iOS8 and below is not supported.';

      static NOROOM_ERROR_TITLE_JP: string = '警告';

      static NOROOM_ERROR_TITLE_EN: string = 'Warning';

      static NOROOM_ERROR_MESSAGE_JP: string = '部屋を配置してください。';

      static NOROOM_ERROR_MESSAGE_EN: string = 'Please input a room.';

      static DEMOMODE_ERROR_TITLE_JP: string = 'デモモード';

      static DEMOMODE_ERROR_TITLE_EN: string = 'Demo Mode';

      static DEMOMODE_ERROR_MESSAGE_JP: string = 'デモモードで起動しています。<br>作成したプランを保存することができません。<br>ご注意ください';

      static DEMOMODE_ERROR_MESSAGE_EN: string = 'You are currently using the demo mode.<br>Please note that you will not be able to save your plan data.';

      static ERROR_INPUT_PASSWORD_JP: string = 'パスワードを入力してください';

      static ERROR_INPUT_PASSWORD_EN: string = 'Please check your password.';

      static ERROR_INPUT_PASSWORD2_JP: string = 'パスワードが違います。';

      static ERROR_INPUT_PASSWORD2_EN: string = 'Please check your password.';

      static ERROR_NETWORK_JP: string = 'パスワードが違います。';

      static ERROR_NETWORK_EN: string = 'Please check your password.';

      static NOTICE_DATA_NOSAVE_JP: string = '変更内容が保存されないことがあります。';

      static NOTICE_DATA_NOSAVE_EN: string = 'Changes have not been saved.';

      static NOTICE_CLOSE_PLAN_AND_NEW_JP: string = '現在編集中のプランを削除して新規作成しますか？';

      static NOTICE_CLOSE_PLAN_AND_NEW_EN: string = 'Would you like to close the current plan and start drawing a new one?';

      static CONFIRM_STYLE_SETTING_JP: string = '設定済みの高さ・屋根形状・色などがリセットされますが、よろしいですか？';

      static CONFIRM_STYLE_SETTING_EN: string = 'Current height, roof style and color settings will be changed accordingly to the style?<br>Would you like to proceed?';

      static CONFIRM_RELOAD_DRAFT_JP: string = '現在の下絵を破棄して、下絵の読込を行いますか？';

      static CONFIRM_RELOAD_DRAFT_EN: string = 'The current draft will be unloaded.<br>Would you like to proceed?';

      static FIREFOX_ERROR_MESSAGE_JP: string = 'Firefoxは対応していません。<br>恐れ入りますが、他のブラウザをお使いください。';

      static FIREFOX_ERROR_MESSAGE_EN: string = 'Firefox is not supported.<br>Please try another browser.';

      static FIREFOX_ERROR_TITLE_JP: string = 'ご注意';

      static FIREFOX_ERROR_TITLE_EN: string = 'Warning';

      static INFO_REGISTER_COMPLETE_JP: string = 'ご入力いただきましたメールアドレスに、本会員登録のご案内をお送りしました。<br>本会員登録を行い、ログインしてから引き続きお使いください。';

      static INFO_REGISTER_COMPLETE_EN: string = 'We have sent you a mail. <br>Please register to continue using.<br>Thank you.';

      static FITTINGSETTING_NO_FITTINGHEIGHT_JP: string = '高さを選択してください。';

      static FITTINGSETTING_NO_FITTINGHEIGHT_EN: string = 'Please select the height';

      static FITTINGSETTING_NO_FITTINGZ_JP: string = '取り付け高さを選択してください。';

      static FITTINGSETTING_NO_FITTINGZ_EN: string = 'Please input the fitting height';

      static NOTICE_SAVED_EXCLUSION_JP: string = 'このデータは他で更新されています。<br />作図中のデータは新規図面として登録しました。作図終了後、データをご確認ください。';

      static NOTICE_SAVED_EXCLUSION_EN: string = 'This plan has been saved by someone else.<br />This plan is saved as a new plan. Please check.';

      static NOTICE_SAVE_ERROR_JP: string = '処理中にエラーが発生しました。お手数ですが、もう一度初めから操作を行ってください。';

      static NOTICE_SAVE_ERROR_EN: string = 'An error occured while saving. Please try over again.';

      static NOTICE_LOAD_ERROR_JP: string = '処理中にエラーが発生しました。お手数ですが、一度ブラウザを閉じて初めから操作を行ってください。';

      static NOTICE_LOAD_ERROR_EN: string = 'An error occured while saving. Please try over again.';

      static NETWORK_ERROR_JP: string = 'ネットワーク環境に問題があるため、<br>ネットワーク環境が良い場所から再度リトライしてください。';

      static NETWORK_ERROR_EN: string = 'ネットワーク環境に問題があるため、<br>ネットワーク環境が良い場所から再度リトライしてください。';

      static WIN7_IE11_ERROR_MESSAGE_JP: string = 'この環境は「Windows7＋InternetExplorer11」をご利用のため、正しく動作しない場合があります。<br>正しく動作しない場合は、ブラウザをGoogle Chrome最新版に変更してご利用ください。';

      static WIN7_IE11_ERROR_MESSAGE_EN: string = "The current environment 'Windows7 and Internet Explorer11' is not recommended.<br>Please use Google Chrome for this application.";

      static WIN7_IE11_ERROR_TITLE_JP: string = 'ご注意';

      static WIN7_IE11_ERROR_TITLE_EN: string = 'Warning';

      static IE_ERROR_MESSAGE_JP: string = 'この環境は「InternetExplorer」をご利用のため、正しく動作しない場合があります。<br>正しく動作しない場合は、ブラウザをGoogle Chrome最新版に変更してご利用ください。';

      static IE_ERROR_MESSAGE_EN: string = "The current environment 'Internet Explorer' is not recommended.<br>Please use Google Chrome for this application.";

      static IE_ERROR_TITLE_JP: string = 'ご注意';

      static IE_ERROR_TITLE_EN: string = 'Warning';

      static ERROR_PASTE_ITEM_JP: string = 'この階に貼り付けられないアイテムが含まれています。';

      static ERROR_PASTE_ITEM_EN: string = 'Contains items that can not be pasted on this floor';

      static NOTICE_TEXTURE_ERROR_JP: string = 'テクスチャの読み込み中にエラーが発生しました。もう一度試してください。';

      static NOTICE_TEXTURE_ERROR_EN: string = 'An error occured while loading Texture. Please try over again.';

      static BEAMSETTING_NO_BEAMHEIGHT_JP: string = '高さを入力してください。';

      static BEAMSETTING_NO_BEAMHEIGHT_EN: string = 'Please input the height';

      static ALERT_INPUT_ITEMNAME_JP: string = 'オブジェクト名を入力してください。';

      static ALERT_INPUT_ITEMNAME_EN: string = 'Please input the Object name.';

      static ALERT_SELECT_GRADE_JP: string = 'グレードを選択してください。';

      static ALERT_SELECT_GRADE_EN: string = 'Please select a grade.';

      static ERROR_LOGIN_ERROR_JP: string = 'ログインチェックに失敗しました。<br>ネットワーク環境をご確認ください。';

      static ERROR_LOGIN_ERROR_EN: string = 'Login check failed. <br>Please check your network environment.';

      static ERROR_JSON_IMPORT_FAIL_JP: string = 'jsonデータのインポートに失敗しました。';

      static ERROR_JSON_IMPORT_FAIL_EN: string = 'Failed to import json data.';

      static SAFARI_ERROR_MESSAGE_JP: string = 'この環境では、３D体験いただけない可能性があります。<br>その場合には、最新のChromeに切り替えてお使いください。';

      static SAFARI_ERROR_MESSAGE_EN: string = 'WebCAD does not support Safari + Mac OS.<br>Please switch to Chrome for the full experience.';

      static NOTICE_PERSPECTIVE_SAVE_ERROR_JP: string = '画像の保存中にエラーが発生しました。お手数ですが、もう一度初めから操作を行ってください。';

      static NOTICE_PERSPECTIVE_SAVE_ERROR_EN: string = 'An error occured while saving image. Please try over again.';

      static NOTICE_PERSPECTIVE_SAVE_SUCCESS_JP: string = 'パース図 保存しました。';

      static NOTICE_PERSPECTIVE_SAVE_SUCCESS_EN: string = 'Image saved';

      static ERROR_NO_PLAN_DOCUMENT_JP: string = '企画ドキュメントが見つかりません';

      static ERROR_NO_PLAN_DOCUMENT_EN: string = 'Project document not found.';

      static ERROR_NO_SELECTABLE_PLAN_DOCUMENT_JP: string = '<span class="centerMessage"><span class="mainText">選択できる画像がありません。</span><span class="subText">※既に使用されている画像や画像以外の<br>ファイルは選択できません。</span></span>';

      static ERROR_NO_SELECTABLE_PLAN_DOCUMENT_EN: string = '<span class="centerMessage"><span class="mainText">No selectable images.</span><span class="subText">*Images already in use and non-image<br>files cannot be selected.</span></span>';

      static ROOMSETTING_NO_ROOMHEIGHT_JP: string = '高さを入力してください。';

      static ROOMSETTING_NO_ROOMHEIGHT_EN: string = 'Please input the height';

      static WALLSETTING_NO_HEIGHT_JP: string = '有効な高さを入力してください。';

      static WALLSETTING_NO_HEIGHT_EN: string = 'Please input valid height.';

      static OUTERWALL_INIT_JP: string = '外壁厚を0に初期化をします。';

      static OUTERWALL_INIT_EN: string = 'Initialize the exterior wall thickness to 0.';

      static ERROR_NO_ATTACHED_DOCUMENT_JP: string = '添付文書が見つかりません。';

      static ERROR_NO_ATTACHED_DOCUMENT_EN: string = 'Attached document not found.';

      static ERROR_ATTACHED_DOCUMENT_DOWNLOAD_JP: string = 'ドキュメントのダウンロード中にエラーが発生しました。もう一度やり直してください。';

      static ERROR_ATTACHED_DOCUMENT_DOWNLOAD_EN: string = 'An error occured while downloading document. Please try over again.';

      static ERROR_NO_ATTACHED_IMAGE_JP: string = '添付画像が見つかりません。';

      static ERROR_NO_ATTACHED_IMAGE_EN: string = 'Attached image not found.';

      static ERROR_ATTACHED_IMAGE_VIEW_JP: string = '画像の閲覧中にエラーが発生しました。もう一度試してください。';

      static ERROR_ATTACHED_IMAGE_VIEW_EN: string = 'An error occurred while viewing the image. Please try again.';

      static ERROR_JSON_IMPORT_LIDAR_ADDITIONAL_PIN_FAIL_JP: string = '追加ピンの読込に失敗しました。<br>追加ピンデータが含まれているデータかご確認ください。';

      static ERROR_JSON_IMPORT_LIDAR_ADDITIONAL_PIN_FAIL_EN: string = 'Failed to import addition lidar pin data. Please check your data';

      static LINK_PIN_ITEM_JP: string = 'ピンとプランデータを紐づけ中...'

      static LINK_PIN_ITEM_EN: string = 'Linking pins to plan data in progress...'

      static ERROR_PIN_REGISTER_JP: string = 'ピンの登録に失敗しました。<br>ドキュメントや画像の割り当て、または付帯工事に関する情報が正確かご確認ください。';

      static ERROR_PIN_REGISTER_EN: string = 'Pin registration failed.<br>Please verify that the allocation of documents and images,<br>as well as the information related to additional construction work, is accurate.';

      static ERROR_EXPORT_JWW_FAIL_JP: string = 'JWWデータのエクスポートに失敗しました。';

      static ERROR_EXPORT_JWW_FAIL_EN: string = 'Failed to export JWW data.';

      static ERROR_EXPORT_DXF_FAIL_JP: string = 'DXFデータのエクスポートに失敗しました。';

      static ERROR_EXPORT_DXF_FAIL_EN: string = 'Failed to export DXF data.';

      static COPY_SHARE_LINK_TITLE_JP: string = 'モデルのリンクをコピー';

      static COPY_SHARE_LINK_TITLE_EN: string = 'Copy Model Link';

      static COPY_SHARE_LINK_DONE_JP: string = 'モデルのリンクをコピーしました。<br>閲覧可能期間は発行から２週間です。';

      static COPY_SHARE_LINK_DONE_EN: string = 'The model link has been copied.<br>The link is available for two weeks from the date of issue.';

      static ERROR_COPY_SHARE_LINK_FAIL_JP: string = 'モデルのリンクの取得に失敗しました。<br>ネットワーク環境をご確認ください。';

      static ERROR_COPY_SHARE_LINK_FAIL_EN: string = 'Failed to get the model link.<br>Please check your network environment.';

      static ERROR_COPY_SHARE_LINK_NO_SAVED_DATA_JP: string = '保存データがないため、モデルのリンクを発行できません。<br>プランを保存してから再度お試しください。';

      static ERROR_COPY_SHARE_LINK_NO_SAVED_DATA_EN: string = 'The model link cannot be issued because there is no saved data.<br>Please save the plan and try again.';

      /**
           * メッセージの取得
           * @param key:string
           */
      static getText(key: string) {
        const varname: string = (`${key}_${marietta.webcad.WebCADGlobal.language}`).toUpperCase();
        return marietta.webcad.collection.WebCADMessages[varname];
      }
}
export default WebCADMessages;
